import React, { createContext, useContext, useState } from 'react';

const ConfirmationContext = createContext();

export const useConfirmation = () => {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error('useConfirmation must be used within ConfirmationProvider');
  }
  return context;
};

export const ConfirmationProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [onConfirmCallback, setOnConfirmCallback] = useState(null);

  const confirm = (message) => {
    return new Promise((resolve) => {
      setMessage(message);
      setIsOpen(true);
      setOnConfirmCallback(() => resolve);
    });
  };

  const handleConfirm = () => {
    if (onConfirmCallback) {
      onConfirmCallback(true);
    }
    setIsOpen(false);
    setMessage('');
    setOnConfirmCallback(null);
  };

  const handleCancel = () => {
    if (onConfirmCallback) {
      onConfirmCallback(false);
    }
    setIsOpen(false);
    setMessage('');
    setOnConfirmCallback(null);
  };

  return (
    <ConfirmationContext.Provider value={{ confirm }}>
      {children}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
            <p className="text-gray-800 text-lg mb-6">{message}</p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={handleCancel}
                className="px-6 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors font-medium"
              >
                Annuler
              </button>
              <button
                onClick={handleConfirm}
                className="px-6 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors font-medium"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmationContext.Provider>
  );
};
